
import { useRef } from "react"
import BasePlane from "./components/BasePlane"


export default function Experience()
{


    return(
        <group>
            <BasePlane />
        </group>
    )
    
}